<!-- 采购订单数据操作 -->
<template>
   <div>
      <div v-if="isLoaded">
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 主要信息 -->
                        <div v-if="scope.index == 0">
                           <el-form label-width="100px" id="mainInfo1" class="baseForm1" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                              <el-row>
                                 <el-form-item label="手术类型" prop="surgeryType" :rules="[{ required: true,  trigger: ['blur', 'change'] }]">
                                    <label slot="label" :style="$common.labelStyle('手术类型')" v-html="$common.htmlLabel('手术类型')+':'"></label>
                                    <el-select v-model="sendDataInfo.surgeryType" clearable placeholder="请选择" :disabled="dataActionBox.actionType==2?true:false">
                                       <el-option v-for="item in typeList" :key="item.id" :label="item.surgeryName" :value="item.id">
                                       </el-option>
                                    </el-select>
                                 </el-form-item>
                                 <el-form-item label="手术包名称" prop="umName" :rules="[{ required: true,  trigger: ['blur', 'change'] }]">
                                    <label slot="label" :style="$common.labelStyle('手术包名称')" v-html="$common.htmlLabel('手术包名称')+':'"></label>
                                    <el-input v-model="sendDataInfo.umName" clearable :disabled="dataActionBox.actionType==2?true:false"></el-input>
                                 </el-form-item>
                                 <el-form-item label="备注" prop="remark">
                                    <label slot="label" :style="$common.labelStyle('备注')" v-html="$common.htmlLabel('备注')+':'"></label>
                                    <el-input type="textarea" v-model="sendDataInfo.remark" :rows="2" :disabled="dataActionBox.actionType==2?true:false">
                                    </el-input>
                                 </el-form-item>
                              </el-row>
                           </el-form>
                           <!-- 明细信息 -->
                           <div>
                              <el-form :inline="true" size="mini">
                                 <div v-if="dataActionBox.actionType != 2" id="operateBtn">
                                    <el-button type="primary" size="mini" @click="addDetail('sendDataInfo')">
                                       新增</el-button>
                                    <el-button type="primary" size="mini" @click="deleteDetails()">删除
                                    </el-button>
                                    <el-button type="primary" size="mini" @click="openExtSearch('283729837729832','pwomId')">提取预出库单</el-button>
                                    <el-link :underline="false" type="danger" style="margin-left: 10px;">
                                       (Alt+F1：新增明细</el-link>
                                    <el-link :underline="false" type="danger" style="margin-left: 10px;">
                                       Alt+F2：删除明细)</el-link>
                                 </div>
                                 <el-table size="mini" class="baseTable" ref="mxTableRef" :data="sendDataInfo.surgerydetailList" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent"
                                           @selection-change="handleSelectionChange" border style="width: 100%" :height="mxHeight">
                                    <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                                       <template slot-scope="scope">
                                          <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                             <i class="el-icon-thumb"></i>
                                          </el-radio>
                                       </template>
                                    </el-table-column>
                                    <el-table-column align="center" prop="bgmName" label="通用名称" show-overflow-tooltip min-width="120">
                                       <template slot-scope="scope">
                                          <el-input @clear="clear(scope.$index, 'bgmName,bgmId')" v-if="dataActionBox.actionType != 2" clearable v-model="sendDataInfo.surgerydetailList[scope.$index].bgmName"
                                                    ref="bgmName" id="bgmName" @keyup.enter.native="openSearch(853533363572736, scope.$index, 'bgmName', 'bgmName,bgmId', 'num',true)">
                                             <el-button @click="openSearch(853533363572736, scope.$index, 'bgmName', 'bgmName,bgmId', 'num',true)" slot="append" icon="el-icon-search">
                                             </el-button>
                                          </el-input>
                                       </template>
                                    </el-table-column>
                                    <el-table-column align="center" prop="bgmCode" label="商品编码" show-overflow-tooltip min-width="120"></el-table-column>
                                    <el-table-column align="center" prop="spec" label="规格" show-overflow-tooltip min-width="120"></el-table-column>
                                    <el-table-column align="center" prop="manufacturer" label="生产厂商" show-overflow-tooltip min-width="120"></el-table-column>
                                    <el-table-column align="center" prop="num" label="数量" show-overflow-tooltip min-width="120">
                                       <template slot-scope="scope">
                                          <el-input v-if="dataActionBox.actionType != 2" clearable v-model="sendDataInfo.surgerydetailList[scope.$index].num" ref="num" id="num">
                                          </el-input>
                                       </template>
                                    </el-table-column>
                                    <el-table-column align="center" prop="remark" label="备注" show-overflow-tooltip min-width="120">
                                       <template slot-scope="scope">
                                          <el-input v-if="dataActionBox.actionType != 2" clearable v-model="sendDataInfo.surgerydetailList[scope.$index].remark" ref="remark" id="remark">
                                          </el-input>
                                       </template>
                                    </el-table-column>
                                    <el-table-column align="center" prop="placeorigin" label="产地" show-overflow-tooltip min-width="120"></el-table-column>
                                    <el-table-column align="center" prop="fileNumber" label="档案编号" show-overflow-tooltip min-width="120"></el-table-column>
                                 </el-table>
                              </el-form>
                           </div>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
         </div>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body="true" :append-to-body="true">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true">
         <ExtractionScheme :extractParamsData="sendDataInfo" ref="extractionScheme" :id="exId" :ppId="ppId" @TranData="getDataByChen" @getWidth="getWidth" @sendTitle="getExtractName" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
      <historicalOrders ref="HistoricalOrders" />
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
   name: "surgicalKitAction",
   props: ["actionData"],
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
   },
   data() {
      //这里存放数据
      return {
         mxHeight: 0,
         dataActionBox: {
            showStatus: false,
            actionType: 0, // 0新增，1修改
         },
         showTabs: "手术包表单",
         tabForm: [
            {
               jciName: "手术包表单",
               jurconfigform: [],
            }
         ], // tab循环的主表单
         footForm: [],
         selectedDetailsIndex: 0,
         sendDataInfo: {
            surgerydetailList: [],
            remark: "",
            surgeryType: "",
            umName: "",
            umId: "",
         },
         detaislDataInfo: {
            bgmId: "",
            bgmCode: "",
            manufacturer: "",
            placeorigin: "",
            fileNumber: "",
            fileNumber: "",
            bgmName: "",
            spec: "",
            num: 0,
            remark: "",
         },
         seId: "",
         seWidth: "",
         seTitle: "",
         seWidth: "",
         DialogVisible: false,
         seType: "",
         smId: "",
         parentSearchData: {},
         isLoaded: false,
         seIndex: 0, //选中索引
         sField: "", // 赋值字段
         fField: "", //焦点字段
         selectedRow: [],
         typeList: [],
         //提取方案
         DialogExtract: false,
         exWidth: "",
         exTitle: "",
         ppId: "",
         exId: "",
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "sendDataInfo.surgerydetailList": {
         handler: function (newValue) {
            newValue.forEach((item, keys) => {
               this.$set(item, 'num', this.$common.updataNum('num', item).num)
            })
         },
         deep: true
      }
   },
   //方法集合
   methods: {
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getExtractName(e) {
         this.exTitle = e;
      },
      //触发提取
      openExtSearch(id, type) {
         this.$refs['sendDataInfo'].validate((valid) => {
            if (valid) {
               this.ppId = type
               this.exId = id;
               this.DialogExtract = true;
            } else {
               return this.$message({
                  message: "请完善必填信息",
                  type: "warning",
               });
            }
         });

      },
      //提取返回
      async getDataByChen(val) {
         console.log("提取返回", val);
         if (val != "" || val != undefined) {
            this.sendDataInfo.surgerydetailList = val.arrlistbychen.map(item => {
               let obj = {}
               Object.keys(this.detaislDataInfo).forEach(key => {
                  if (item[key] != undefined && item[key] != null && item[key] !== '') {
                     this.$set(obj, key, item[key])
                  }else{
                     this.$set(obj, key, this.detaislDataInfo[key])
                  }
               })
               return obj
            })
         }
         this.DialogExtract = false;
      },
      clear(index, setField) {
         var arr = setField.split(',')
         arr.forEach(val => {
            this.sendDataInfo.surgerydetailList[index][val] = ''
         })
      },

      // 表格切换焦点方法
      tableNextFocus(field, index) {
         if (field == "keydown") {
            this.addDetail("sendDataInfo");
            if (this.sendDataInfo.surgerydetailList[index + 1] != undefined) {
               this.$refs["bgmName"][index + 1].focus();
               return;
            }
            return;
         }
         if (this.$refs[field][index]) {
            this.$refs[field][index].focus();
         } else {
            this.$refs[field].focus();
         }
      },
      showPrintPlan() {
         // 打印方法
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            console.log("选中的数据", this.actionData);
            this.$refs.printPlan.openDia(
               this.actionData.orderId,
               this.actionData.printSouce,
               this.actionData.printJurId
            );
         } else {
            return;
         }
      },
      toDetail(orderId) {
         this.$parent.$parent.$parent.toDetail(orderId);
      },
      //换行提示
      lineMessageBox(data) {
         let txtArr = data.message.split("<br/>");
         let newArr = [];
         const h = this.$createElement;
         for (const i in txtArr) {
            newArr.push(h("p", null, txtArr[i]));
         }
         this.$alert(h("div", null, newArr), "提示", {
            confirmButtonText: "确定",
            callback: (action) => { },
         });
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.sendDataInfo[item] = val[item];
         });
         this.$nextTick(() => {
            this.nextFocus(this.seIndex);
         });
      },
      // 清除赋值字段数据
      clearValue() {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.sendDataInfo[item] = "";
         });
      },
      //提取返回
      changeInputModel(val) {
         console.log("返回", val, this.seType);
         if (val != "" && val != undefined) {
            this.DialogVisible = false;
            addEventListener("keyup", this.keyUp); //创建监听键盘事件
            if (this.seType == 'bgmName') {
               for (const key in this.sendDataInfo.surgerydetailList[this.seIndex]) {
                  if (val[key] != undefined && val[key] != null) {
                     this.$set(this.sendDataInfo.surgerydetailList[this.seIndex], key, val[key])
                  }
               }
               this.tableNextFocus(this.fField, this.selectedDetailsIndex);
            }
         }
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      // 检索Id, 索引(表格中), 标识
      //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
      openSearch(sId, index, type, sField, fField) {
         this.DialogVisible = true;
         removeEventListener("keyup", this.keyUp);
         this.seId = sId;
         this.seIndex = index;
         this.seType = type;
         this.sField = sField;
         this.fField = fField;
         this.selectedDetailsIndex = index
         this.parentSearchData[type] = this.sendDataInfo[type];
         if (type == 'bgmName') {
            this.parentSearchData.surgeryType = this.sendDataInfo.surgeryType
            this.parentSearchData.bgmName = this.sendDataInfo.surgerydetailList[index].bgmName
         }
      },
      //新增明细
      addDetail(sendDataInfo) {
         var flag = false;
         if (this.sendDataInfo.surgerydetailList.length > 0) {
            this.sendDataInfo.surgerydetailList.forEach((item) => {
               if (item.bgmId == "") {
                  flag = true;
                  return this.$message({
                     message: "请不要重复新增空白行",
                     type: "warning",
                  });
               }
            });
         }
         if (flag) {
            return;
         }
         this.$refs[sendDataInfo].validate((valid) => {
            if (valid) {
               this.sendDataInfo.surgerydetailList.push({});
               var index = this.sendDataInfo.surgerydetailList.length - 1;
               for (const key in this.detaislDataInfo) {
                  this.$set(
                     this.sendDataInfo.surgerydetailList[index],
                     key,
                     this.detaislDataInfo[key]
                  );
               }
               this.$nextTick(() => {
                  this.selectedDetailsIndex = Number(
                     this.sendDataInfo.surgerydetailList.length - 1
                  );
                  this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                  let refsElTable = this.$refs.mxTableRef;
                  refsElTable.clearSelection();
                  refsElTable.toggleRowSelection(
                     this.sendDataInfo.surgerydetailList[this.selectedDetailsIndex]
                  );
               });
            } else {
               return this.$message({
                  message: "请完善必填信息",
                  type: "warning",
               });
            }
         });
      },
      initActionBox(sendDataInfo) {
         var cancelTitle = this.dataActionBox.actionType == 0 ? "新增" : "修改";
         this.$confirm("确定取消" + cancelTitle + "吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.$emit("drawerCancel", 0);
               this.init();
               this.$refs[sendDataInfo].resetFields();
            })
            .catch(() => { });
      },
      init() {
         for (let key in this.sendDataInfo) {
            if (key == "surgerydetailList") {
               this.sendDataInfo[key] = [];
            } else {
               this.sendDataInfo[key] = "";
            }
         }
      },

      openBox() {
         this.dataActionBox.actionType = this.actionData.cate;
         var oldData = this.actionData.oldData;
         if (this.dataActionBox.actionType == 0) {
            this.init()
         } else if (this.dataActionBox.actionType == 1) {
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key]);
            }
            this.sendDataInfo.surgeryType = Number(this.sendDataInfo.surgeryType)
            this.$nextTick(() => {
               this.selectedDetailsIndex = 0;
               setTimeout(() => {
                  let refsElTable = this.$refs.mxTableRef;
                  refsElTable.clearSelection();
                  refsElTable.toggleRowSelection(
                     this.sendDataInfo.surgerydetailList[this.selectedDetailsIndex]
                  );
               }, 16.7);
            });
         } else {
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            this.sendDataInfo.surgeryType = Number(this.sendDataInfo.surgeryType)
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key]);
            }
         }
         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight();
               } else {
                  this.mxHeight = this.$common.getHeight();
               }
            }, 16.7);
         });
      },
      //确认
      sendDataAction(sendDataInfo) {
         this.$refs[sendDataInfo].validate((valid) => {
            if (valid) {
               this.sub()
            } else {
               return this.$message({
                  message: "请完善必填信息",
                  type: "warning",
               });
            }
         });

      },
      async sub() {
         var arr = []
         this.sendDataInfo.surgerydetailList.forEach(item => {
            arr.push({
               psodId: item.psodId,
               rowno: item.rowno,
            })
         })
         var sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
         if(sendData.umId && typeof sendData.umId === 'string' && sendData.umId.includes("_")){
            sendData.umId=sendData.umId.split("_")[0]
         }
         sendData.surgerydetailList = this.sendDataInfo.surgerydetailList.map(item => {
            return {
               bgmId: item.bgmId,
               num: item.num,
               remark: item.remark,
               udId: item.udId || "",
               umId: item.umId,
            }
         })
         var responseData
         if (this.dataActionBox.actionType == 1) {
            responseData = await this.$http.surgerymasterupdate(sendData);
         } else {
            responseData = await this.$http.surgerymasteradd(sendData);
         }
         if (responseData.status == 200) {
            this.init();
            this.$message({
               message: "操作成功",
               type: "success",
            });
            this.$emit("drawerCancel", 1);
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      deleteDetails() {
         if (this.sendDataInfo.surgerydetailList.length < 1) {
            return this.$message({
               message: "暂无可删除明细",
               type: "warning",
            });
         }
         this.sendDataInfo.surgerydetailList.splice(this.selectedDetailsIndex, 1);
         if (this.sendDataInfo.surgerydetailList.length > 1) {
            this.selectedDetailsIndex = Number(this.selectedDetailsIndex - 1);
         } else {
            this.selectedDetailsIndex = 0;
         }
         this.tableNextFocus("bgmName", this.selectedDetailsIndex);
         let refsElTable = this.$refs.mxTableRef;
         refsElTable.clearSelection();
         refsElTable.toggleRowSelection(
            this.sendDataInfo.surgerydetailList[this.selectedDetailsIndex]
         );
      },
      // 保存已选择行
      handleSelectionChange(rows) {
         this.selectedRow = rows; // 保存已选择行
      },
      // 明细表格点击选中
      clickEvent(row, column, event, params) {
         let refsElTable = this.$refs.mxTableRef; // 获取表格对象
         let findRow = {};
         this.selectedDetailsIndex = row.rowIndex;
         findRow = this.selectedRow.find((c) => c.rowIndex == row.rowIndex); //找出当前选中行
         //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
         if (findRow && this.selectedRow.length === 1) {
            refsElTable.toggleRowSelection(row, false);
            return;
         }
         refsElTable.clearSelection();
         refsElTable.toggleRowSelection(row);
      },
      // 表格方法
      rowClassName({ row, rowIndex }) {
         let rowName = "",
            findRow = this.selectedRow.find((c) => c.rowIndex === row.rowIndex);
         if (findRow) {
            rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
         }
         return rowName; //也可以再加上其他类名 如果有需求的话
      },
      // 选中行底色逻辑
      rowStyle({ row, rowIndex }) {
         Object.defineProperty(row, "rowIndex", {
            // 给每行添加不可枚举属性rowIndex来标识当前行
            value: rowIndex,
            writable: true,
            enumerable: false,
         });
         let rowBackground = {};
         if (row.bgColor && row.bgColor != "")
            rowBackground.backgroundColor = row.bgColor;
         return rowBackground;
      },
      // 监听键盘事件
      keyUp(e) {
         if (e.key == "F1") {
            // 右键新增明细
            e.preventDefault();
            this.addDetail("sendDataInfo");
            return;
         } else if (e.key == "F2") {
            e.preventDefault();
            this.deleteDetails();
         } else if (e.keyCode == 40) {
            // 下键
            // 表格为空，不执行下方
            if (this.sendDataInfo.surgerydetailList.length == 0) return;
            let refsElTable = this.$refs.mxTableRef;
            this.$nextTick(() => {
               if (this.selectedRow.length == 0) {
                  // 如果当前没有选中行，则直接选中第一个
                  this.selectedDetailsIndex = 0;
               } else if (
                  this.selectedDetailsIndex ==
                  this.sendDataInfo.surgerydetailList.length - 1
               ) {
                  // 如果选中的是最后一行了，那么下一行选中的是第一行
                  this.selectedDetailsIndex = 0;
               } else {
                  // 正常递增
                  this.selectedDetailsIndex++;
               }
               if (!refsElTable) return;
               let findRow = this.selectedRow.find(
                  (c) => c.rowIndex == this.selectedDetailsIndex
               ); //找出当前选中行
               //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
               if (findRow && this.selectedRow.length === 1) {
                  refsElTable.toggleRowSelection(
                     this.sendDataInfo.surgerydetailList[
                     this.selectedDetailsIndex
                     ],
                     false
                  );
                  return;
               }
               this.tableNextFocus("bgmName", this.selectedDetailsIndex);
               refsElTable.clearSelection();
               refsElTable.toggleRowSelection(
                  this.sendDataInfo.surgerydetailList[this.selectedDetailsIndex]
               ); // 把现在当前行勾选
            });
         } else if (e.keyCode == 38) {
            // 上键
            if (this.sendDataInfo.surgerydetailList.length == 0) return;
            let refsElTable = this.$refs.mxTableRef;
            this.$nextTick(() => {
               if (this.selectedRow.length == 0) {
                  // 当前没有选中行，则直接选中第一个
                  this.selectedDetailsIndex = 0;
               } else if (this.selectedDetailsIndex == 0) {
                  // 如果选中的是第一行了，那么下一行选中的是最后一行
                  this.selectedDetailsIndex =
                     this.sendDataInfo.surgerydetailList.length - 1;
               } else {
                  // 正常递减
                  this.selectedDetailsIndex--;
               }
               if (!refsElTable) return;
               let findRow = this.selectedRow.find(
                  (c) => c.rowIndex == this.selectedDetailsIndex
               ); //找出当前选中行
               //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
               if (findRow && this.selectedRow.length === 1) {
                  refsElTable.toggleRowSelection(
                     this.sendDataInfo.surgerydetailList[
                     this.selectedDetailsIndex
                     ],
                     false
                  );
                  return;
               }
               this.tableNextFocus("bgmName", this.selectedDetailsIndex);
               refsElTable.clearSelection();
               refsElTable.toggleRowSelection(
                  this.sendDataInfo.surgerydetailList[this.selectedDetailsIndex]
               ); // 把现在当前行勾选
            });
         }
      },
      async getType() {
         const res = await this.$http.dictSurgeryqueryList({ surgeryName: "" })
         if (res.status == 200) {
            this.typeList = res.result
         }
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.$nextTick(() => {
         this.openBox();
         this.getType()
         this.isLoaded = true;
      });
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {
      addEventListener("keyup", this.keyUp); //创建监听键盘事件
   },
   beforeDestroy() {
      removeEventListener("keyup", this.keyUp);
   },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { }, //生命周期 - 更新之后
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.table_content_box {
   /* height: 500px !important; */
   overflow-y: auto;
}

.el-row {
   display: flex;
   flex-wrap: wrap;
   padding-right: 20px;
}

.el-drawer {
   outline: none;
}

.v-modal {
   position: static !important;
   width: 100%;
   height: 100%;
   background: transparent;
}

::v-deep .el-alert__content {
   width: 100%;
}
</style>